import { render } from "./confirm_modal.vue?vue&type=template&id=36525e2a&scoped=true"
import script from "./confirm_modal.js?vue&type=script&lang=js&external"
export * from "./confirm_modal.js?vue&type=script&lang=js&external"

import "./confirm_modal.vue?vue&type=style&index=0&id=36525e2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36525e2a"]])

export default __exports__